var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VNavigationDrawer',{staticClass:"home-right-sidebar",attrs:{"width":320,"app":"","right":"","clipped":"","permanent":"","stateless":""}},[_c('div',{staticClass:"ctn"},[_c('HomeRecentAcquisitions'),_c('EquipmentsConfigureKit')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }